import React from 'react';

const Coin = ({
  rank,
  name,
  price,
  symbol,
  marketcap,
  volume,
  image,
  priceChange
}) => {
  return (
    <div className='coin-row'>
      <div className='coin'>
        <p className='coin-rank'>#{rank}</p>
        <img className='coin-image' src={image} alt='crypto' />
        <div className='coin-name-symbol'>
          <h3 className='coin-name'>{name}</h3>
          <p className='coin-symbol'>{symbol}</p>
        </div>
      </div>
      <div className='coin-data'>
        <p className='coin-price'>{price}</p>
        <p className='coin-marketcap'>{marketcap}</p>

        {priceChange < 0 ? (
          <p className='coin-change red'>{priceChange.toFixed(3)}%</p>
        ) : (
          <p className='coin-change green'>+{priceChange.toFixed(3)}%</p>
        )}

        <p className='coin-volume'>{volume}</p>
      </div>
    </div>
  );
};

export default Coin;